import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const OutlinedButton = styled(Button)<{ isDelete?: boolean }>(({ theme, isDelete }) => ({
   borderColor: isDelete ? theme.palette.error.dark : theme.palette.primary.main,
   borderRadius: 3,
   textTransform: 'uppercase',
   fontSize: 11,
   fontWeight: 'bold',
   backgroundColor: 'white',
   color: isDelete ? theme.palette.error.dark : theme.palette.primary.main,
   ...(isDelete && {
      '&:hover': {
         backgroundColor: 'rgba(183,33,54,0.05)',
         borderColor: theme.palette.error.darker,
      },
   }),
}))

export default OutlinedButton
